export default __webpack_public_path__ + "static/media/svg4.70ff00ad.svg";